import { FC } from 'react';
import { TaskQuestion, TaskAnswers, TaskAnswer, TaskAnswerLetter, AnswerMark, answerLetter } from './TaskCard';

export interface TaskResponse {
  isCorrect: boolean,
  /** Index of the chosen answer (quiz only) */
  answer?: number,
  responseText?: string
}

interface BlockTaskQuizProps {
  taskData: any,
  /** The answer given earlier, which locks the task and shows the result */
  userAnswer?: TaskResponse,
  completeCallback: (wasCorrect: boolean, answer?: number, response?: string) => void
}

/**
 * Render a quiz task. Once answered, the correct answer turns green and a wrong choice red.
 * @returns {JSX.Element} Component template
 */
const BlockTaskQuiz: FC<BlockTaskQuizProps> = ({taskData, userAnswer, completeCallback}) => {

  /**
   * Result state of answer i: the correct answer is always marked, the chosen one also when it is wrong
   */
  const getState = (answer: any, i: number): "correct" | "wrong" | undefined => {
    if (!userAnswer) { return undefined; }
    if (answer?.correct) { return "correct"; }
    return i === userAnswer.answer ? "wrong" : undefined;
  };

  return (
    <>
      <TaskQuestion>{taskData?.question}</TaskQuestion>
      <TaskAnswers>
        {taskData?.answers?.map((answer: any, i: number) => {
          if (!answer?.answer?.length) { return null; }
          const state = getState(answer, i);
          return (
            <TaskAnswer key={`answer${i}`} className={state} disabled={Boolean(userAnswer)}
              onClick={() => completeCallback(Boolean(answer.correct), i, answer.response)}>
              <TaskAnswerLetter aria-hidden="true">{state ? <AnswerMark correct={state === "correct"}/> : answerLetter(i)}</TaskAnswerLetter>
              <span>{answer.answer}</span>
            </TaskAnswer>
          );
        })}
      </TaskAnswers>
    </>
  );
}

export default BlockTaskQuiz;
